import { retrieveSelfMerchantGroup } from "@/services/merchantGroup/retrieveSelfMerchantGroup"
import type { ClientCurrencyCode } from "@/services/sharedTypes/tenants"

type Merchant = {
  name: string
  hasSalesModule: boolean
  hasDonationsModule: boolean
  schemaName: string
}

type MerchantGroup = {
  id: string
  name: string
  merchants: Array<Merchant>
  currency: ClientCurrencyCode
}

const merchantGroup = ref<MerchantGroup | null>(null)

// This means the `whenever` watcher will only be created once, not in every component that calls `useMerchantGroupAdmin`
const useMerchantGroupWatchers = createSharedComposable(
  () => {
    const { isLoggedInMerchantGroup } =
      useMerchantGroupAuth()

    whenever(
      () => isLoggedInMerchantGroup.value,
      async () => {
        const response = await retrieveSelfMerchantGroup()
        merchantGroup.value = response
      },
      { immediate: true }
    )
    return true // Needed until we update vueuse: https://github.com/vueuse/vueuse/commit/a24411ed23d3bc9e07ab7ea718a29c6de4a0bceb
  }
)

export const useMerchantGroup = () => {
  useMerchantGroupWatchers()

  return readonly(merchantGroup)
}
